'use client';

import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';

import { LineItem } from '@/types';

import Image from '../Image';
import SectionHeading from '../SectionHeading';

export const TEST_ID = 'order-line-item';
export interface OrderLineItemProps {
  readonly className?: string;
  readonly lineItem: LineItem;
  readonly condensed?: boolean;
}

const OrderLineItem = ({
  className,
  lineItem,
  condensed: isCondensed,
}: OrderLineItemProps): JSX.Element => {
  const { description, image, title } = lineItem;
  const width = isCondensed ? (image.width as number) / 2 : image.width;
  const height = isCondensed ? (image.height as number) / 2 : image.height;

  return (
    <div
      data-testid={TEST_ID}
      className={cx(className, 'grow flex items-center gap-4 md:gap-5')}
    >
      <div className="flex-none">
        {image?.src ? (
          <Image
            data-testid="product-image"
            src={image.src}
            alt={image.alt}
            width={width}
            height={height}
            className={image.className}
          />
        ) : null}
      </div>

      <div
        className={cx('flex-1', {
          'flex justify-between items-center gap-x-4 flex-wrap': isCondensed,
        })}
      >
        {title && (
          <SectionHeading
            Element="h3"
            {...(isCondensed ? { variant: 'body-large' } : { weight: 'bold' })}
          >
            {title}
          </SectionHeading>
        )}

        {description && <Typography Element="div">{description}</Typography>}
      </div>
    </div>
  );
};

export default OrderLineItem;
